import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import ErrorBoundary from "../../../../ErrorBoundary";
import { Skeleton, Tooltip } from "antd";
import isEqual from "react-fast-compare";

const TwitterTrendKpi = (props) => {
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const trendsKpiData = useSelector(
    (state) => state?.Screens?.screen?.deep_dive?.twitter_trend
  );
  const googleTrendResult = useSelector(
    (state) =>
      state?.Screens?.screen?.deep_dive?.twitter_trend?.googleTrendResult
  );
  const brandRelatedMentions = useSelector(
    (state) =>
      state?.Screens?.screen?.deep_dive?.twitter_trend?.brandRelatedMentions
  );
  const googleTrendKpiData = useMemo(() => {
    return googleTrendResult?.data?.kpi?.[0];
  }, [googleTrendResult]);
  const brandTrendKpiData = useMemo(() => {
    return brandRelatedMentions?.data?.kpi?.[0];
  }, [brandRelatedMentions]);
  return (
    <>
      {trendsKpiData ? (
        <div className="p-0 m-0 mb-sm-3">
          <div className="row">
            <div className="col-sm-12 col-lg-12 pr-md-0 ">
              <div className="d-md-flex">
                <span className="bg__white border border-radius-4 p-15 mr-md-3 w-100">
                  <div className="portlet__title font-size14 font-weight500 mb-1 d-flex align-items-center ">
                    {"Keyword"}
                  </div>
                  <div className="portlet__content--color fontSize-21 font-weight600">
                    <Tooltip
                      title={deepdive_object?.deepdive_on?.x_axis?.value?.toLocaleString()}
                    >
                      {deepdive_object?.deepdive_on?.x_axis?.value?.toLocaleString()}
                    </Tooltip>
                  </div>
                </span>
                <span className="bg__white border border-radius-4 p-15  mr-md-3 w-100">
                  {googleTrendKpiData ? (
                    <>
                      <div className="portlet__title font-size14 font-weight500 mb-1 d-flex align-items-center ">
                        {googleTrendKpiData?.text
                          ? googleTrendKpiData?.text
                          : "Google Trends Results"}
                        {googleTrendKpiData?.info_help_text ? (
                          <Tooltip
                            title={googleTrendKpiData?.info_help_text}
                            placement="top"
                            className="text-ellipsis d-inline-block"
                          >
                            <i className="fa fa-question-circle cursor-pointer ml-1" />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                        {googleTrendKpiData?.info_text ? (
                          <Tooltip
                            title={googleTrendKpiData?.info_text}
                            placement="top"
                            className="text-ellipsis d-inline-block wm-chart-card-title"
                          >
                            <i className="fa fa-info-circle cursor-pointer ml-1" />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </div>
                      <div
                        className="portlet__content--color fontSize-21 font-weight600"
                        style={
                          googleTrendKpiData?.text_color &&
                          googleTrendKpiData?.text_color !== "#000000"
                            ? { color: googleTrendKpiData?.text_color }
                            : {}
                        }
                      >
                        <Tooltip
                          title={googleTrendKpiData?.value?.toLocaleString()}
                        >
                          {googleTrendKpiData?.value?.toLocaleString()}
                        </Tooltip>
                      </div>
                    </>
                  ) : (
                    <Skeleton active size="small" paragraph={{ rows: 1 }} />
                  )}
                </span>
                <span className="bg__white border border-radius-4 p-15 mr-md-3 w-100">
                  <div className="portlet__title font-size14 font-weight500 mb-1 d-flex align-items-center ">
                    {"Twitter Volume"}
                  </div>
                  <div className="portlet__content--color fontSize-21 font-weight600">
                    <Tooltip
                      title={deepdive_object?.deepdive_on?.y_series?.value?.toLocaleString()}
                    >
                      {deepdive_object?.deepdive_on?.y_series?.value?.toLocaleString()}
                    </Tooltip>
                  </div>
                </span>
                <span className="bg__white border border-radius-4 p-15 mr-md-3 w-100">
                  {brandTrendKpiData ? (
                    <>
                      <div className="portlet__title font-size14 font-weight500 mb-1 d-flex align-items-center ">
                        {brandTrendKpiData?.text
                          ? brandTrendKpiData?.text
                          : "Related Mentions"}
                        {brandTrendKpiData?.info_help_text ? (
                          <Tooltip
                            title={brandTrendKpiData?.info_help_text}
                            placement="top"
                            className="text-ellipsis d-inline-block"
                          >
                            <i className="fa fa-question-circle cursor-pointer ml-1" />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                        {brandTrendKpiData?.info_text ? (
                          <Tooltip
                            title={brandTrendKpiData?.info_text}
                            placement="top"
                            className="text-ellipsis d-inline-block wm-chart-card-title"
                          >
                            <i className="fa fa-info-circle cursor-pointer ml-1" />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </div>
                      <div
                        className="portlet__content--color fontSize-21 font-weight600"
                        style={
                          brandTrendKpiData?.text_color &&
                          brandTrendKpiData?.text_color !== "#000000"
                            ? { color: brandTrendKpiData?.text_color }
                            : {}
                        }
                      >
                        <Tooltip
                          title={brandTrendKpiData?.value?.toLocaleString()}
                        >
                          {brandTrendKpiData?.value?.toLocaleString()}
                        </Tooltip>
                      </div>
                    </>
                  ) : (
                    <Skeleton active size="small" paragraph={{ rows: 1 }} />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="p-0 m-0 mb-sm-3 bg__gray">
          <div className="row">
            <div className="col-sm-12 col-lg-12 pr-md-0 ">
              <div className="d-md-flex">
                <span className="bg__white border border-radius-4 p-15 mr-md-3 w-100">
                  <Skeleton active size="small" paragraph={{ rows: 1 }} />
                </span>
                <span className="bg__white border border-radius-4 p-15  mr-md-3 w-100">
                  <Skeleton active size="small" paragraph={{ rows: 1 }} />
                </span>
                <span className="bg__white border border-radius-4 p-15 mr-md-3 w-100">
                  <Skeleton active size="small" paragraph={{ rows: 1 }} />
                </span>
                <span className="bg__white border border-radius-4 p-15 mr-md-3 w-100">
                  <Skeleton active size="small" paragraph={{ rows: 1 }} />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(TwitterTrendKpi, isEqual);
